import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Access from "constants/Access";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
];

export default class Product extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {


		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/products/${this.props.id}`,
				icon: 'barcode',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Details" value="details"/>
					<Tab label="History" value="history"/>
					{this.props.userAccess <Access.Supervisor&&<Tab label="Change Log" value="logs"/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.ProductUpdate
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</div>
				{this.state.tab === 'history' &&
				<Collections.ProductsHistories
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'logs' && this.props.userAccess <Access.Supervisor&&
				<Collections.LogsProducts
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		);
	}
};